import { Text } from "@clipboard-health/ui-components";
import { differenceInMinutes } from "date-fns";
import pluralize from "pluralize";

import { ShiftBottomSheetBookabilityCriteriaCard } from "./BookabilityCriteriaCard";
import { BookabilityCriteriaCardTitleText } from "./BookabilityCriteriaCardTitleText";

export interface ShiftBottomSheetTierShiftCardProps {
  priorityTill: Date;
}

export function ShiftBottomSheetTierShiftCard(props: ShiftBottomSheetTierShiftCardProps) {
  const { priorityTill } = props;

  const minutesRemaining = differenceInMinutes(priorityTill, new Date());

  return (
    <ShiftBottomSheetBookabilityCriteriaCard
      intent="tiers"
      title={
        <BookabilityCriteriaCardTitleText>
          This shift is exclusive to{" "}
          <Text
            inline
            semibold
            variant="h5"
            sx={(theme) => ({ color: theme.palette.tiers?.gold.text })}
          >
            Gold
          </Text>{" "}
          members for the next {minutesRemaining} {pluralize("minute", minutesRemaining)}
        </BookabilityCriteriaCardTitleText>
      }
      description="Only you and other Gold members can book for now."
      illustrationType="priority-tiers"
    />
  );
}
